import { render } from "./DetailComponent1.vue?vue&type=template&id=7e1d4730&scoped=true"
import script from "./DetailComponent1.vue?vue&type=script&lang=js"
export * from "./DetailComponent1.vue?vue&type=script&lang=js"

import "./DetailComponent1.vue?vue&type=style&index=0&id=7e1d4730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1d4730"]])

export default __exports__